import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';

import { AppConfig } from '../../../config';

@Injectable()
export class PolazniciPopisService {

  constructor(private _http: Http) { }

  dohvatiPolaznike(vrstaKorisnika: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'dohvati_sve_polaznike_za_admina_i_predavaca/', vrstaKorisnika)    
    .map(res => res.json()); 
  }

  noviPolaznik(polaznikPodaci: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'polaznik_spremi/', polaznikPodaci)    
    .map(res => res.json()); 
  }

  polaznikUredi(polaznikPodaci: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'polaznik_uredi/', polaznikPodaci)    
    .map(res => res.json()); 
  }

}


// WEBPACK FOOTER //
// C:/Users/TomislavS/Projekti/31-Holspico-VirtualnaUcionica/VirtualnaUcionica-Web/src/app/pages/virtualna-ucionica/polaznici-popis/polaznici-popis.service.ts